import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faSpinner } from "@fortawesome/free-solid-svg-icons";

function DeleteAnnouncementModal({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  item = null,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden p-6 text-center animate-in fade-in zoom-in-95 duration-200">
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-red-50 text-red-500 flex items-center justify-center text-xl">
          <FontAwesomeIcon icon={faTrash} />
        </div>
        <h3 className="text-lg font-bold text-[#033362] mb-1">
          Delete Announcement
        </h3>
        <p className="text-sm text-gray-500 mb-2">
          Are you sure you want to delete this announcement?
        </p>
        {item && (
          <div className="bg-gray-50 p-3 rounded-xl text-xs text-gray-700 font-medium mb-5 border border-gray-100 max-h-24 overflow-y-auto">
            {item.text_ar || item.text_en}
          </div>
        )}
        <div className="flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-5 py-2 rounded-xl border border-gray-300 text-gray-600 font-medium text-sm hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="flex items-center gap-2 px-5 py-2 rounded-xl bg-red-600 hover:bg-red-700 text-white font-medium text-sm transition-all shadow-md shadow-red-500/20 disabled:opacity-50"
          >
            {loading && <FontAwesomeIcon icon={faSpinner} className="animate-spin" />}
            <span>Delete</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAnnouncementModal;
